import React, { useState } from 'react';
import {
  PlainButton,
  PaddingWrapper,
  DrawerHeader,
} from 'components/styled-components';
import { Drawer, Button, Icon } from '@blueprintjs/core';
import FormTextGroup from 'components/forms/components/form-text-group';
import FormSelectGroup from 'components/forms/components/form-select-group';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { createUser } from 'api/users';
import { Intent } from '@blueprintjs/core';
import { AppToaster } from 'components/AppToaster';
import colors from 'utils/colors';
import styled from 'styled-components';
import Loading from 'components/loading';

const UserSchema = Yup.object().shape({
  firstName: Yup.string()
    .min(2, 'Too Short!')
    .max(50, 'Too Long!')
    .required('Required'),
  lastName: Yup.string()
    .min(2, 'Too Short!')
    .max(50, 'Too Long!')
    .required('Required'),
  email: Yup.string()
    .email('Invalid email')
    .required('Required'),
});

const AddContact = ({
  vendorID,
  vendorName,
  fetchVendorContacts,
  addBtnLabel,
  drawerLabel,
  drawerBtnLabel,
  handleFormSubmit,
  icon,
  addMobileStyle,
	vendors
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const close = () => setIsOpen(false);

  const handleSaveUser = (user, actions) => {
    user = {
      ...user,
      thirdParties: [{ vendorID }],
      role: { roleName: 'THIRD_PARTY' },
    };
    createUser(user)
      .then(res => {
        AppToaster.show({
          message: res.data.message,
          intent: Intent.SUCCESS,
        });
        actions.setSubmitting(false);
        fetchVendorContacts(vendorName);
        close();
      })
      .catch(err => {
        actions.setSubmitting(false);
        AppToaster.show({
          message: err.response.data.message,
          intent: Intent.DANGER,
        });
      });
  };
	
  return isOpen ? (
    <Drawer isOpen={isOpen} onClose={close}>
      <Formik
        initialValues={{ firstName: '', lastName: '', email: '' }}
        validationSchema={UserSchema}
        onSubmit={(v, a) => {
          handleFormSubmit
            ? handleFormSubmit(v, a, close)
            : handleSaveUser(v, a);
        }}
      >
        {({ handleChange, values, isSubmitting, isValid }) => (
          <Form>
            <DrawerHeader>
              <span>{drawerLabel || 'Add User'}</span>
              <div style={{ display: 'flex' }}>
                <Button minimal large text="Cancel" onClick={close} />
                <PlainButton
                  display="flex"
                  type="submit"
                  disabled={isSubmitting || !isValid}
                >
                  {drawerBtnLabel || 'SAVE'}
                  {isSubmitting && (
                    <span style={{ marginLeft: '1rem' }}>
                      <Loading size={20} />
                    </span>
                  )}
                </PlainButton>
              </div>
            </DrawerHeader>
            <PaddingWrapper padding="2rem">
              <FormTextGroup
                label="First Name"
                requiredLabel={true}
                name="firstName"
                value={values.firstName}
                handleChange={handleChange}
              />
              <FormTextGroup
                label="Last Name"
                requiredLabel={true}
                name="lastName"
                value={values.lastName}
                handleChange={handleChange}
              />
              <FormTextGroup
                label="Email Address"
                requiredLabel={true}
                name="email"
                value={values.email}
                handleChange={handleChange}
              />
							<FormSelectGroup
								label="Third Party Name"
								requiredLabel={true}
								name="thirdPartyIDs"
								asyncOptions={[{ vendorID: vendorID, vendorName: vendorName }]}
								labelKey="vendorName"
								valueKey="vendorID"
								value={{ vendorID: vendorID, vendorName: vendorName }}
								disabled={true}
								onChange={(key, value) => {
									handleChange({target: {name: key, value: value}});
								}}
								isClearable={true}
							/>
									
            </PaddingWrapper>
          </Form>
        )}
      </Formik>
    </Drawer>
  ) : (
    <ContactBtnWrapper>
      <Button onClick={() => setIsOpen(true)} intent={Intent.PRIMARY}>
        <span className={addMobileStyle && 'btnLabel'}>
          {addBtnLabel || 'Add Contact'}
        </span>
        <span className={addMobileStyle && 'btnIcon'}>
          <Icon icon={icon} color={colors.white} iconSize="16" />
        </span>
      </Button>
    </ContactBtnWrapper>
  );
};

const ContactBtnWrapper = styled.span`
  .btnIcon {
    display: none;
  }
  @media (max-width: 1300px) {
    .btnIcon {
      display: flex;
    }
    .btnLabel {
      display: none;
    }
  }
`;

export default AddContact;
